import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { IAttribute, IModel } from '../../base/annotation';
import { Metamodel } from '../../base/model';
import { SftpServerLinkedService } from '../../linkedservice/sftp-server.linkedservice';
import { FilePath } from '../file-path';
import { ILocationPath, Location } from './location';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'SftpLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SftpServerLinkedService)
    }
})
export class SftpLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', SftpLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', SftpLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: SftpLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: SftpLocation.FILE_NAME.templateValue(this) || this.fileName
        };
    }


    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && SftpLocation.FILE_NAME.templateValue(this) ? false : !this.fileName;
    }
    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(SftpLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(SftpLocation.FILE_NAME.templateValue(this));
    }
}
